var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewList24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 5L4.49885 19L21.4989 19.0014L21.5 5.00139L4.5 5ZM8.49984 7.00033L8.49967 9.00033L6.49967 9.00016L6.49984 7.00016L8.49984 7.00033ZM6.49951 11.0002L6.49934 13.0002L8.49934 13.0003L8.49951 11.0003L6.49951 11.0002ZM6.49918 15.0002L8.49918 15.0003L8.49902 17.0003L6.49902 17.0002L6.49918 15.0002ZM10.499 17.0005L19.499 17.0012L19.4992 15.0012L10.4992 15.0005L10.499 17.0005ZM19.4993 13.0012L10.4993 13.0005L10.4995 11.0005L19.4995 11.0012L19.4993 13.0012ZM10.4997 9.00049L19.4997 9.00123L19.4998 7.00123L10.4998 7.00049L10.4997 9.00049Z",
    fill: "#505255"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewList24Px);
export default __webpack_public_path__ + "static/media/view_list_24px.9305adb862317012e56e8fad4ca57b24.svg";
export { ForwardRef as ReactComponent };